import request from '@/utils/request'

/** 配料列表/统计查询较重，多人同时访问时适当放宽超时 */
const MM_REQUEST_TIMEOUT_MS = 60000

export const getOrderItemMaterialMatchings = (params, config = {}) => {
  return request({
    url: '/api/order-item-material-matchings',
    method: 'get',
    params,
    timeout: MM_REQUEST_TIMEOUT_MS,
    ...config
  })
}

/** 配料池数量：未完成 / 完成待派工 / 完成已派工 / 出货与请款分池（可选 customer_ids、owner_user_id、internal_color_en 与列表一致） */
export const getOrderItemMaterialMatchingPoolCounts = (params) => {
  return request({
    url: '/api/order-item-material-matchings/pool-counts',
    method: 'get',
    params: params || {},
    timeout: MM_REQUEST_TIMEOUT_MS
  })
}

/** 配料筛选：订单类型选项（含 non_bulk=全部样品、non_sample=全部大货） */
export const getOrderItemMaterialMatchingOrderTypeOptions = () =>
  request({
    url: '/api/order-item-material-matchings/order-type-filter-options',
    method: 'get'
  })

/** 分页页签计数（材料页/业务状态页） */
export const getOrderItemMaterialMatchingPageCounts = (params) => {
  return request({
    url: '/api/order-item-material-matchings/page-counts',
    method: 'get',
    params,
    timeout: MM_REQUEST_TIMEOUT_MS
  })
}

/** 手动：校正账单已结清的进行中订单为完结（不拖慢日常列表） */
export const refreshSettledMatchingOrders = (data = {}) =>
  request({
    url: '/api/order-item-material-matchings/refresh-settled-orders',
    method: 'post',
    data,
    timeout: 120000
  })

/** 手动：归档取消配料行（部分取消只挪行）；整单皆取消则订单改为 cancelled */
export const archiveCancelledMatchingOrders = (data = {}) =>
  request({
    url: '/api/order-item-material-matchings/archive-cancelled-orders',
    method: 'post',
    data,
    timeout: 120000
  })

/** 手动：按订单号免请款完结并移出配料管理（赠送单等；需独立权限） */
export const archiveNoBillMatchingOrders = (data = {}) =>
  request({
    url: '/api/order-item-material-matchings/archive-no-bill-orders',
    method: 'post',
    data,
    timeout: 120000
  })

export const adoptColorFormulationBatch = (orderItemId, data = {}) => {
  return request({
    url: `/api/order-items/${orderItemId}/adopt-color-formulation-batch`,
    method: 'post',
    data
  })
}

export const saveOrderItemMaterialMatching = (orderItemId, data) => {
  return request({
    url: `/api/order-items/${orderItemId}/material-matching`,
    method: 'post',
    data
  })
}

export const updateOrderItemMaterialMatching = (orderItemId, data) => {
  return request({
    url: `/api/order-items/${orderItemId}/material-matching`,
    method: 'put',
    data
  })
}

/** 仅更新多批分摊的「现场实际用量」（不改计划分摊） */
export const patchOrderItemMatchingLinesActualUsed = (orderItemId, data) => {
  return request({
    url: `/api/order-items/${orderItemId}/material-matching-lines/actual-used`,
    method: 'patch',
    data
  })
}

export const completeOrderItemMaterialMatching = (orderItemId) => {
  return request({
    url: `/api/order-items/${orderItemId}/material-matching/complete`,
    method: 'post'
  })
}

/** 配料页拆分订单明细：先出部分数量，余量另起一行 */
export const splitOrderItemMatchingLine = (orderItemId, data) => {
  return request({
    url: `/api/order-items/${orderItemId}/split-matching-line`,
    method: 'post',
    data
  })
}

export const getSmartMaterialMatch = (orderItemId) => {
  return request({
    url: `/api/order-items/${orderItemId}/smart-material-match`,
    method: 'get'
  })
}

export const getMaterialSelectionHistory = (orderItemId) => {
  return request({
    url: `/api/order-items/${orderItemId}/material-history`,
    method: 'get'
  })
}

export const getSmartBatchMatch = (orderItemId) => {
  return request({
    url: `/api/order-items/${orderItemId}/smart-batch-match`,
    method: 'get'
  })
}

export const getBatchSelectionHistory = (orderItemId) => {
  return request({
    url: `/api/order-items/${orderItemId}/batch-history`,
    method: 'get'
  })
}

/** 快捷动作待跟进：purchase 用 material_batch_id；processing 用 order_item_id（仅本行） */
export const bulkSetActionFollowUp = (data) => {
  return request({
    url: '/api/order-item-material-matchings/action-follow-up-bulk',
    method: 'post',
    data
  })
}

/** 一键补同步：把配料已取消但销售明细未取消的历史数据同步回销售明细 */
export const syncCancelledMatchingsToOrderItems = () => {
  return request({
    url: '/api/order-item-material-matchings/sync-cancelled-to-order-items',
    method: 'post'
  })
}

/** @deprecated 请用 bulkSetActionFollowUp({ action: 'purchase', ... }) */
export const bulkSetProcurementFollowUp = (data) => {
  return bulkSetActionFollowUp({ ...data, action: 'purchase' })
}

/** 批量确认交期：items=[{ order_item_id, confirmed_delivery_date }], lock 默认 true */
export const bulkConfirmDeliveryDates = (data) => {
  return request({
    url: '/api/order-item-material-matchings/confirm-delivery-bulk',
    method: 'post',
    data,
    timeout: 120000
  })
}

/** 一键自动配料（用库存）预览 */
export const previewAutoMatch = (params = {}, data = {}) => {
  return request({
    url: '/api/order-item-material-matchings/auto-match/preview',
    method: 'post',
    params,
    data
  })
}

/** 一键自动配料（用库存）确认写入 */
export const applyAutoMatch = (data) => {
  return request({
    url: '/api/order-item-material-matchings/auto-match/apply',
    method: 'post',
    data
  })
}

